import { createContext, useContext, useState, useEffect, useCallback } from "react";
import { apiRequest } from "../services/api";
import { setExportOtelAdi } from "../utils/exportUtils";
import { getApiUrl } from "../config/demoMode";

const AuthContext = createContext();

const API_URL = getApiUrl();

function parseYetkiler(json) {
  try { return json ? JSON.parse(json) : {}; } catch { return {}; }
}

export const AuthProvider = ({ children }) => {
  const [personel, setPersonel] = useState(null);
  const [loading, setLoading] = useState(true);

  // Sayfa yenilendiğinde cookie geçerliyse /me ile oturumu geri yükle
  // Not: apiRequest değil, raw fetch — 401 global redirect'ini tetiklememesi için
  useEffect(() => {
    if (!API_URL) {
      setLoading(false);
      return;
    }

    fetch(`${API_URL}/Auth/me`, { credentials: "include" })
      .then(res => (res.ok ? res.json() : null))
      .then(data => {
        if (data) {
          setPersonel(data);
          setExportOtelAdi(data.otelAdi);
        }
      })
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  const loginUser = (data) => {
    setPersonel(data);
    setExportOtelAdi(data.otelAdi);
  };

  const demoSonTarih = personel?.demoSonTarih ? new Date(personel.demoSonTarih) : null;
  const isDemoHesap = !!personel?.isDemoOtel;

  const refreshOtelAdi = useCallback(async () => {
    if (!personel?.otelId) return;
    try {
      const otel = await apiRequest(`otel/${personel.otelId}`);
      if (otel?.ad) setPersonel(prev => prev ? { ...prev, otelAdi: otel.ad } : prev);
    } catch {}
  }, [personel?.otelId]);

  const logoutUser = async () => {
    try {
      await fetch(`${API_URL}/Auth/logout`, { method: "POST", credentials: "include" });
    } catch {}
    setPersonel(null);
  };

  const hasYetki = (key) => {
    if (!personel) return false;
    const yetkiler = parseYetkiler(personel.yetkilerJson);
    return yetkiler[key] === true;
  };

  const isAdmin = () => personel?.tip === 'Yönetici';
  const hasYetkiOrAdmin = (key) => isAdmin() || hasYetki(key);

  return (
    <AuthContext.Provider value={{ personel, loading, loginUser, logoutUser, hasYetki, hasYetkiOrAdmin, isAdmin, refreshOtelAdi, isDemoHesap, demoSonTarih }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
